import * as Yup from 'yup'

const WithoutEmailSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email is invalid.')
    .required('Required field.'),
})

export default WithoutEmailSchema
